module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.hasPermission('CAN_UPLOAD_BULK')) ? _c('v-card', [(_vm.message) ? _c('v-alert', {
    attrs: {
      "value": "message",
      "type": "success",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.message) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": "error",
      "type": "warning",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.error) + " ")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pa-4": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('label', [_vm._v("File\n         "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "#1f5b41"
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 mt-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.files,
      "pagination": _vm.pagination,
      "total-items": _vm.totalFiles,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.fileName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.approved))])]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddf05332"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/merchant/BulkUpload.vue
// module id = 1077
// module chunks = 2